var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"box scanning"},[_c('video',{attrs:{"id":"video","width":"720","height":"560","autoplay":"","muted":""},domProps:{"muted":true}}),_c('div',{attrs:{"id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }